import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { userLogin } from 'react-admin'
import classnames from 'classnames'
import { Card, makeStyles, Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'

const useStyles = makeStyles(
  theme => ({
    main: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      height: '1px',
      alignItems: 'center',
      justifyContent: 'flex-start',
      backgroundColor: '#F2F2F2',
    },
    card: {
      minWidth: 300,
      marginTop: '6em',
      backgroundColor: '#F2F2F2',
      boxShadow: 'none',
    },
    avatar: {
      margin: '1em',
      display: 'flex',
      justifyContent: 'center',
    },
    icon: {
      backgroundColor: theme.palette.secondary[500],
    },
    form: {
      display: 'flex',
      alignItems: 'center',
    },
    buttonGoogleContainer: {
      textDecoration: 'none',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
    },
    buttonGoogle: {
      margin: '1em auto 2em',
      padding: '.2em .5em',
      textTransform: 'none',
    },
    logoGoogle: {
      width: 20,
      height: 20,
      backgroundColor: '#fff',
      padding: '.3em',
      borderRadius: 3,
    },
    local: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      margin: '0 1em 2em',
    },
    localHint: {
      marginBottom: '1em',
      textAlign: 'center',
      color: '#666',
    },
    localButton: {
      marginBottom: '.5em',
      textTransform: 'none',
      justifyContent: 'flex-start',
    },
    localRole: {
      marginLeft: '.5em',
      color: '#999',
    },
  }),
  { name: 'RaLogin' },
)

// docker-compose sets this; a deployed build never has it, so the SAML button
// below stays the only way in.
const isLocal = process.env.REACT_APP_APP_ENV === 'local'

const localLoginUrl = email =>
  `${process.env.REACT_APP_API_URL}/auth/local-login${
    email ? `?email=${encodeURIComponent(email)}` : ''
  }`

const MyLoginPage = props => {
  const { className } = props
  const classes = useStyles(props)
  const { search } = props.location

  const [accounts, setAccounts] = useState([])

  const hasToken = search.startsWith('?token=')
  // authProvider.logout() sends you to /login?pick=1 in local, so logging out
  // lands on the account list instead of bouncing straight back in.
  const pickAccount = /[?&]pick=/.test(search)

  if (hasToken) {
    const token = search.replace('?token=', '')
    props.userLogin(token)
  }

  useEffect(() => {
    if (!isLocal || hasToken) return

    if (!pickAccount) {
      window.location.assign(localLoginUrl())
      return
    }

    // Read from the database server-side, so the list cannot drift away from
    // what the seed migration actually created.
    fetch(`${process.env.REACT_APP_API_URL}/auth/local-users`)
      .then(response => response.json())
      .then(setAccounts)
      .catch(() => setAccounts([]))
  }, [hasToken, pickAccount])

  return (
    <div className={classnames(classes.main, className)}>
      <Card className={classes.card}>
        <div className={classes.avatar}>
          <img src="/logo_isdin.png" alt="isdin" />
        </div>
        {isLocal && !hasToken ? (
          <div className={classes.local}>
            <Typography
              variant="caption"
              component="div"
              className={classes.localHint}
            >
              {pickAccount
                ? 'Local development — SAML bypassed, pick a seeded account'
                : 'Local development — signing you in…'}
            </Typography>
            {accounts.map(account => (
              <Button
                key={account.email}
                className={classes.localButton}
                variant="contained"
                color="primary"
                href={localLoginUrl(account.email)}
              >
                {`${account.name} ${account.surname}`}
                <span className={classes.localRole}>
                  {account.role.replace('ROLE_', '')}
                </span>
              </Button>
            ))}
            {pickAccount && accounts.length === 0 && (
              <Button
                className={classes.localButton}
                variant="contained"
                color="primary"
                href={localLoginUrl()}
              >
                Sign in as the seeded admin
              </Button>
            )}
          </div>
        ) : (
          <form className={classes.form}>
            <a
              className={classes.buttonGoogleContainer}
              href={`${process.env.REACT_APP_API_URL}/auth/sso-login`}
            >
              <Button
                className={classes.buttonGoogle}
                startIcon={(
                  <img
                    className={classes.logoGoogle}
                    src="/google.png"
                    alt="google"
                  />
                )}
                variant="contained"
                color="primary"
              >
                Sign in with Google
              </Button>
            </a>
          </form>
        )}
      </Card>
    </div>
  )
}

export default connect(undefined, { userLogin })(MyLoginPage)
